// const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL;
const ROOT_URL_SERVER = import.meta.env.VITE_API_URL;
const ROOT_URL_PLATFORM = import.meta.env.VITE_PLATFORM_URL;

export const API_URL = `${ROOT_URL_SERVER}/api`;

export const ADMIN_URL = `${ROOT_URL_PLATFORM}/admin`;

export const PLATFORM_URL = `${ROOT_URL_PLATFORM}/v2`;

export const APP_BASENAME = '/v2';

export const TICKETS_URLS = {
  TICKETS: '/tickets',
  TICKET_COMPLEXITY_SURVEY: '/ticket_complexity_survey',
};

export const AUTH_URLS = {
  LOGIN_TOKEN_ACRONEX: `/auth`,
  LOGIN_SESSION_ACRONEX: `/session_auth`,
  USER_CONTEXT: `/user_context`,
  CHECK_USER_AUTH: `/check_user_auth`,
  LOGIN_PLA: `/pla_auth`,
  LOGOUT: '/session_logout',
};

export const PACKAGE_URLS = {
  PHOTOS: '/packages_photos',
  PACKAGE_ITEMS: '/packages_items',
  ADDRESS_BY_CEP: '/address_by_postal_code',
};
export const SERVICE_ORDER_URLS = {
  SERVICE_ORDER_ITEMS: '/service_orders_items',
  UPLOAD_BILL_FILE: '/service_orders/{id}/bill_file',
};

export const MACHINES_URLS = {
  GET_MACHINES: '/moviles',
  ADMIN_MOVIL: '/machines/movil',
};

export const COMPANY_URLS = {
  API_URL: `/empresas`,
  ADMIN_EMPRESA: '/serveradmin/empresa',
  GET_CONTACT: '/company_contact',
  PAYMENT_METHOD: '/payment_methods',
  PAYMENT_METHOD_RESOURCE: 'payment_methods',
};

export const TECHNICIAN_URLS = {
  ADMIN: '/serveradmin/tecnico',
};

export const DEVICE_URLS = {
  SEND_TOKEN: `/devices`,
};

export const USER_URLS = {
  NOTIFICATIONS: `/notifications`,
};

export const PRODUCT_CATALOG_URLS = {
  PRODUCT_CATEGORIES: 'product_categories',
};

export const MESSAGE_URLS = {
  MESSAGES: '/messages',
};
